export default class FaceAPI {
  constructor(baseURI) {
    this._baseURI = baseURI;
    this._apiURI = this._baseURI + "/wp-json/kidworks/v1/faces";
  }

  getFaceById(id) {
    return fetch(this._apiURI + "/" + id)
      .then((r) => r.json())
      .then(({ post_title, acf_fields, thumbnail }) => ({
        name: post_title,
        city: acf_fields.city,
        role: acf_fields.role,
        imageSrc: thumbnail,
        contentRows: acf_fields.content_rows,
      }));
  }
}
